<script>
    import {sgettext} from '../../i18n.js';
    export let row = {};
</script>

<!-- This handling of mapping template_status to its translation key is poor, but is being replaced by the new React implementation -->
{#if row.template_status.toLowerCase() === 'current'}
  <span class="badge badge-pill badge-current">{sgettext('$$CURRENT$$')}</span>
{:else if row.template_status.toLowerCase() === 'draft'}
  <span class="badge badge-pill badge-draft">{sgettext('$$DRAFT$$')}</span>
{:else if row.template_status.toLowerCase() === 'expired'}
  <span class="badge badge-pill badge-expired">{sgettext('$$EXPIRED$$')}</span>
{:else if row.template_status.toLowerCase() === 'pending'}
  <span class="badge badge-pill badge-pending">{sgettext('$$PENDING$$')}</span>
{:else if row.template_status.toLowerCase() === 'declined'}
  <span class="badge badge-pill badge-declined">{sgettext('$$DECLINED$$')}</span
  >
{:else if row.template_status.toLowerCase() === 'awaiting strategy approval'}
  <span class="badge badge-pill badge-light"
    >{sgettext('$$AWAITING_STRATEGY_APPROVAL$$')}</span
  >
{:else if row.template_status.toLowerCase() === 'awaiting review'}
  <span class="badge badge-pill badge-light"
    >{sgettext('$$AWAITING_REVIEW$$')}</span
  >
{:else if row.template_status.toLowerCase() === 'awaiting control owner approval'}
  <span class="badge badge-pill badge-light"
    >{sgettext('$$AWAITING_CONTROL_OWNER_APPROVAL$$')}</span
  >
{:else if row.template_status.toLowerCase() === 'awaiting activity approval'}
  <span class="badge badge-pill badge-light"
    >{sgettext('$$AWAITING_ACTIVITY_APPROVAL$$')}</span
  >
{:else if row.template_status.toLowerCase() === 'review declined'}
  <span class="badge badge-pill badge-light"
    >{sgettext('$$REVIEW_DECLINED$$')}</span
  >
{:else if row.template_status.toLowerCase() === 'control owner approval declined'}
  <span class="badge badge-pill badge-light"
    >{sgettext('$$CONTROL_OWNER_APPROVAL_DECLINED$$')}</span
  >
{:else if row.template_status.toLowerCase() === 'strategy approval declined'}
  <span class="badge badge-pill badge-light"
    >{sgettext('$$STRATEGY_APPROVAL_DECLINED$$')}</span
  >
{:else if row.template_status.toLowerCase() === 'activity approval declined'}
  <span class="badge badge-pill badge-light"
    >{sgettext('$$ACTIVITY_APPROVAL_DECLINED$$')}</span
  >
{:else if row.template_status}
  <span class="badge badge-pill badge-light l10nerror"
    >{sgettext(row.template_status)}</span
  >
{/if}

<style>
  .badge-light {
    color: #454545;
    border: 1px solid #454545;
  }
  .badge-current {
    color: white;
    background-color: #5cb85c;
  }
  .badge-pending {
    color: white;
    background-color: #0da2ff;
  }

  .badge-declined {
    color: white;
    background-color: #ff0a14;
  }

  .badge-expired {
    color: white;
    background-color: #adadad;
  }
  .badge-draft {
    color: #2b2b2b;
    background-color: white;
    border: 1px solid #2b2b2b;
  }
  .badge {
    margin: 0 3px;
  }
</style>
